import { useMemo } from 'react';
import usePermissions from 'hooks/usePermissions';
import useAccountStore from 'store/accountStore';
import { ContentLoading } from 'components/system/Loading';
import Page from 'components/system/Page';
import { useGetTeamMembersMap } from 'selectors/team.selector';
import useTeamStore from 'store/teamStore';
import { auth, useAuthState } from 'api/services/firebase';
import JobsFilters from './JobsFilters';
import JobsContent from './JobsContent';
import JobsTitle from './JobsTitle';

const teamJobsColumns = [
  {
    key: 'owner',
    label: 'User',
  },
  {
    key: 'jobName',
    label: 'Name',
  },
  {
    key: 'jobId',
    label: 'Job ID',
  },
  {
    key: 'runStatus',
    label: 'Status',
  },
  {
    key: 'device',
    label: 'Device',
  },
  {
    key: 'cost',
    label: 'Cost',
  },
  {
    key: 'createdOn',
    label: 'Start',
  },
  {
    key: 'runEnd',
    label: 'Finished Time',
  },
];

const TeamJobs = ({
  jobs,
  total,
  isLoading,
  refetch,
  isRefetching,
  filters,
  page,
  perPage,
  onPageChange,
  onRowsPerPageChange,
  onFilterChange,
  handleSearch,
  searchQuery,
}) => {
  const { hasPermission } = usePermissions();
  const [user] = useAuthState(auth);

  const teamId = useAccountStore((state) => state.activeAccount.teamId);
  const isTeamLoading = useTeamStore((state) => state.members.isLoading);

  const teamMembersMap = useGetTeamMembersMap();
  const jobOwnersMap = hasPermission('jobs.team.search')
    ? teamMembersMap
    : { [user.uid]: { displayName: user.displayName } };
  const teamJobs = useMemo(() => (jobs?.map((job) => ({
    ...job,
    owner: jobOwnersMap[job.userId]?.displayName,
  }))), [page, perPage, isLoading, isTeamLoading, isRefetching, filters]);

  const handleJobOwnerFilterChange = (name, value) => {
    onFilterChange(name, value);
  };

  return (
    <Page title={<JobsTitle refetch={refetch} />}>
      {hasPermission('jobs.team.search') && (
        <JobsFilters
          filters={filters}
          teamId={teamId}
          onFilterChange={handleJobOwnerFilterChange}
        />
      )}
      {
        (isLoading || isRefetching)
          ? (<ContentLoading />)
          : (
            <JobsContent
              columns={teamJobsColumns}
              jobs={teamJobs}
              page={page}
              total={total}
              rowsPerPage={perPage}
              setPage={onPageChange}
              setRowsPerPage={onRowsPerPageChange}
              handleSearch={handleSearch}
              searchQuery={searchQuery}
              onFilterChange={onFilterChange}
              filters={filters}
            />
          )
      }
    </Page>
  );
};

export default TeamJobs;
